module.exports = __webpack_public_path__ + "img/content1.453196db.png";